import { transport } from 'config/transport';

export function callApiUpdateStudent(classId, id, studentBody) {
    return transport.put(`/mamnon/classes/${classId}/students/${id}`, studentBody);
}
